import { render, staticRenderFns } from "./PatternChangePassword.vue?vue&type=template&id=1791e089&scoped=true&"
import script from "./PatternChangePassword.vue?vue&type=script&lang=js&"
export * from "./PatternChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./PatternChangePassword.vue?vue&type=style&index=0&id=1791e089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791e089",
  null
  
)

export default component.exports